<template>
  <div>
    <b-row v-if="post.image" class="mt-2 mb-4">
      <b-col md="3" class="mt-2 col-7">
        <b-img-lazy fluid :src="post.image" :alt="post.name + ' image'"></b-img-lazy>
      </b-col>
      <b-col md="9" class="mt-2">
        <h2 class="accent">{{ post.name }}</h2>
        <p class="text-dark mb-1 mt-n1">
          <span>{{ post.date }}</span>
          {{ post.description }}
        </p>
        <router-link :to="'/search/' + tag" v-for="tag in post.tags" :key="tag">
          <span class="badge badge-decode">{{ tag }}</span>
        </router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col id="post" v-html="marked"></b-col>
    </b-row>
  </div>
</template>
<script>
import * as hljs from "highlight.js";
import * as mdit from "markdown-it";

export default {
  data() {
    return {
      post:
        (JSON.parse(sessionStorage.getItem("data")) || []).find(
          p => p.url == this.$route.params.title
        ) || {},
      marked: null
    };
  },
  methods: {
    render(post) {
      document.querySelectorAll('[data-href-add="post"]').forEach(el => {
        el.href = el.getAttribute("data-href");
        el.setAttribute("data-href-add", "done");
      });
      document.title = "Decode - " + this.post.name;
      let self = this;
      if (post.body.startsWith("http")) {
        fetch(post.body)
          .then(res => res.text())
          .then(function(markdown) {
            const md = mdit({
              html: true,
              xhtmlOut: true,
              linkify: true,
              highlight: function(str, lang) {
                if (lang && hljs.getLanguage(lang)) {
                  try {
                    return hljs.highlight(lang, str).value;
                  } catch (err) {
                    console.error(err);
                  }
                }

                return ""; // use external default escaping
              }
            });
            let rendered = md.render(markdown);
            self.marked = rendered;
            let newPost = post;
            newPost.body = rendered;
            let posts = JSON.parse(sessionStorage.getItem("data"));
            posts[
              posts.indexOf(posts.find(x => x.url == newPost.url))
            ] = newPost;
            sessionStorage.setItem("data", JSON.stringify(posts));
            // self.marked = markdown;
          });
      } else {
        this.marked = post.body;
      }
    }
  },
  beforeMount() {
    let vm = this;
    if (!this.post || !this.post.name) {
      this.$nextTick(() => {
        fetch("https://api.dancodes.online/api/v2/fetch")
          .then(res => res.json())
          .then(data => data.blog)
          .then(function(posts) {
            sessionStorage.setItem("data", JSON.stringify(posts));
            vm.post = posts.find(x => x.url == vm.$route.params.title);
            if (!vm.post) {
              return (window.location.href = "/");
            }
            vm.render(vm.post);
          });
      });
    } else {
      this.render(this.post);
    }
  }
};
</script>
